module.exports = "<!-- <div class=\"section-full-height\" id=\"manage-export-list\">\n  <uh-oh-message class=\"uh-oh-message\" ng-show=\"noPermission\" message=\"You do not have permission to view this page.\">\n  </uh-oh-message>\n\n  <export-list\n    date=\"{{ date }}\"\n    event-id=\"{{ eventId }}\"\n    export-type=\"dataExportType\"\n    organization-member-id=\"{{ organizationMemberId }}\"\n    venue-id=\"{{ venueId }}\"\n  ></export-list>\n</div> -->\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/manageExportList/manageExportList.html
// module id = 1160
// module chunks = 0